/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var app = require('mag-app'),
    keys = require('stb-keys'),
    AdClass = require('./advertising.class'),
    currentReq,
    advertising = {
        /**
         * Get ads link to play
         *
         * @param {number} place - place id to get video
         * @param {Function} callback - callback  after getting video link
         */
        getAd: function ( place, callback ) {

            place = place || this.CODE_APP_START;
            currentReq = core.backend.request('/advertising?place=' + place, {
                onload: function ( error, response ) {
                    if ( !error && response && response.data && callback ) {
                        callback(error, response.data.map(function ( ad ) {
                            return new AdClass(ad);
                        }));
                    } else if ( error && callback ) {
                        callback(error, []);
                    } else if ( callback ) {
                        callback(true, []);
                    }
                },
                onerror: function () {
                    if ( callback ) {
                        callback(true, []);
                    }
                }
            });
        }
    };

//
// |  4 | stb      |           201 | Start applications                     |
// |  5 | stb      |           202 | Before starting the film in Video Club |
// |  6 | stb      |           203 | During movie playback in Video Club    |
// | 23 | stb      |           204 | Before starting the TV channel         |
// | 24 | stb      |           205 | During a TV channel playback           |

/**
 * Code to get info about Start applications advertising
 * @type {number} code
 */
advertising.CODE_APP_START = 201;

/**
 * Code to get info about Before starting the film in Video Club advertising
 * @type {number} code
 */
advertising.CODE_VIDEO_CLUB_START_PLAYBACK = 202;

/**
 * Code to get info about During movie playback in Video Club advertising
 * @type {number} code
 */
advertising.CODE_VIDEO_CLUB_DURING_PLAYBACK = 203;

/**
 * Code to get info about Before starting the TV channel advertising
 * @type {number} code
 */
advertising.CODE_TV_START_PLAYBACK = 204;

/**
 * Code to get info about During a TV channel playback advertising
 * @type {number} code
 */
advertising.CODE_TV_DURING_PLAYBACK = 205;

// stop request to prevent callback
app.addListener('keydown', function ( event ) {
    if ( event.code === keys.exit && currentReq ) {
        currentReq.abort();
    }
});


module.exports = advertising;
